export const ascendBy = (propName: string) => (a: object, b: object) => a[propName] - b[propName];